import type { ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

/** Title, then description 4px under it. An Icon first lifts the top padding from 20 to 24. */
export function DialogHeader({ className, children }: ComponentProps<'div'>) {
  return (
    <div
      className={twMerge('flex flex-shrink-0 flex-col gap-1 px-6 pb-6 pt-5 has-[[data-dialog-icon]]:pt-6', className)}
    >
      {children}
    </div>
  )
}
